<!-- for guest user -->
<!-- <section class="guest__user grey__background" [ngClass]="userLoggedIn ? 'd-none' : ''">
  <div class="container-fluid">
    <div class="feature-section_heading full__width mb-0 guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">Stay Informed: Login for sports updates</h2>
        <p class="content_des">Sign in to receive the latest news and updates on your favorite sports.</p>
      </div>
      <a routerLink="/auth/login" class="common--button postion__right text-align-center">Login now</a>
    </div>
  </div>
</section> -->
<!-- Footer opened -->
<footer class="footer">
  <div class="container-fluid">
    <div class="footer__menu">
      <div class="footer_row">
        <div class="footer_column">
          <div class="footer-logo">
            <img ngSrc="../../../../assets/images/white-logo.png" alt="footer logo" width="200" height="23" />
          </div>
          <ul class="address_info">
            <li>
              <a href="mailto:debra.xdge@example.com">
                <span [innerHTML]="ICONS.emailIcon | safeHtml"></span>
                debra.xdge&#64;example.com
              </a>
            </li>
            <li>
              <a href="tel:4805550103">
                <span [innerHTML]="ICONS.callIcon | safeHtml"></span>
                (480) 555-0103
              </a>
            </li>
            <li class="social_media_icon">
              <button>
                <!-- <img src="../../../../assets/images/Ic_facebook.svg" width="22" height="22" alt="facebook icon" /> -->
                <span [innerHTML]="ICONS.facebook | safeHtml"></span>
              </button>
              <button>
                <!-- <img src="../../../../assets/images/ic_insta.svg" width="22" height="22" alt="instagram icon" /> -->
                <span [innerHTML]="ICONS.instagram | safeHtml"></span>
              </button>
              <button>
                <!-- <img src="../../../../assets/images/ic_linkedin.svg" width="22" height="22" alt="linkedin icon" /> -->
                <span [innerHTML]="ICONS.linkedin | safeHtml"></span>
              </button>
            </li>
          </ul>
        </div>
        <div class="footer_column">
          <ul class="footer__menu--link">
            <li><a (click)="taptotop()" routerLink="/about-us">About Us</a></li>
            <li><a (click)="taptotop()" routerLink="/what-we-offer">What we offer</a></li>
            <li><a (click)="taptotop()" routerLink="/privacy-policy">Privacy Policy</a></li>
            <li><a (click)="taptotop()" routerLink="/terms-conditions">Terms & Conditions</a></li>
            <li><a (click)="taptotop()" routerLink="/faqs">FAQs</a></li>
          </ul>
        </div>
        <div class="footer_column">
          <ul class="footer__menu--link">
            <li><a [routerLink]="userInfo?.id ? '/sports' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'sports')">Sports</a></li>
            <li>
              <a [routerLink]="userInfo?.id ? '/events/eventByOthers' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'event')">Events</a>
            </li>
            <!-- <li><a href="{{ storeUrl }}">Xdge Store</a></li> -->
            <li>
              <a [routerLink]="userInfo?.id ? '/store' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'XDGE Store')">Xdge Store</a>
            </li>
            <li><a [routerLink]="userInfo?.id ? '/media' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'media')">Media</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright_content text-align-center">
      <p>© XDGE 2014-{{ date | date: 'yyyy' }}. All rights reserved.</p>
    </div>
  </div>
</footer>
<!-- Footer closed -->
